import React from "react";
import { Navigate, Route, Routes } from "react-router-dom";
import PaymentList from "./List";
import PaymentCreate from "./Create";
import PaymentDetail from "./Detail";
import { connect } from "react-redux";

const defaultFields = {
  ApplicationType: { visible: false, label: '', required: false },
  AssessmentDate: { visible: false, label: '', required: false },
  Summary: { visible: false, label: '', required: false },
  Currency: { visible: false, label: '', required: false },
  ProjectOrders: { visible: false, label: '', required: false },
  OtherCumulativePrice: { visible: false, label: '', required: false },
  OtherAmountPaid: { visible: false, label: '', required: false },
  SubTotalPay: { visible: false, label: '', required: false },
  SubTotalRetain: { visible: false, label: '', required: false },
  OtherAmountRetain: { visible: false, label: '', required: false },
  LastPaymentCertificateAmount: { visible: false, label: '', required: false },
  OtherCertifiedPretax: { visible: false, label: '', required: false },
  OtherTaxAmount: { visible: false, label: '', required: false },
  OtherCertifiedAmount: { visible: false, label: '', required: false },
  PurchaseOrderNumber: { visible: false, label: '', required: false },
}

///ALL FIELDS ARE DECIDED WITHIN THE getFields FUNCTION
///THE getFields FUNCTION IS CALLED WITHIN THE adjustContractTemplate and assign fields to workflowItem
export const getFields = (resources, placeholdersQA, workflowsQA, languageFile, wfid, globalResources, contract) => {
  const fields = { ...defaultFields };

  const workflowItem = workflowsQA[wfid];
  let clauses = workflowItem.clauses;
  if (!clauses) {
    ///IF UnifiedClauses not defined use legacy placeholders
    if (wfid === 21 && placeholdersQA.ApplicationTypes) {
      clauses = placeholdersQA.ApplicationTypes.values.filter(item => item.isActive === true);
    } else if (wfid === 20 && placeholdersQA.PaymentTypes) {
      clauses = placeholdersQA.PaymentTypes.values.filter(item => item.isActive === true);
    }
  }

  fields.ApplicationType = { visible: true, label: languageFile["GENERAL.FIELD.APPLICATIONTYPE"], required: true };

  fields.ApplicationType.clauses = clauses;

  if (resources.AssessmentDayLabel) {
      fields.AssessmentDate = { visible: true, label: resources.AssessmentDayLabel, required: true };
  }
  if (resources.SummaryDetailsLabel) {
      fields.Summary = { visible: true, label: resources.SummaryDetailsLabel, required: true };
  }

  //batchPaymentForPackagedContractEnabled
  if (workflowsQA['72'] && contract.ispackaged) {
      fields.ProjectOrders = { visible: true, label: workflowsQA['72'].notificationName, required: true };
  } else {
      fields.Currency = { visible: true, label: languageFile["GENERAL.FORMS.CURRENCY"], required: true };
  }

  if (resources.CumulativePriceLabel) {
      fields.OtherCumulativePrice = { visible: true, label: resources.CumulativePriceLabel, required: true };
  }
  if (resources.PlusAmountsSupplierLabel) {
      fields.OtherAmountPaid = { visible: true, label: resources.PlusAmountsSupplierLabel, required: true };
  }
  
  fields.SubTotalPay = { visible: true, label: languageFile["CONTRACT.WF.PAYMENT.FIELD.SUB_TOTAL"], required: true };

  if (resources.LessAmountsSupplierLabel) {
      fields.SubTotalRetain = { visible: true, label: resources.LessAmountsSupplierLabel, required: true };
  }

  fields.OtherAmountRetain = { visible: true, label: languageFile["CONTRACT.WF.PAYMENT.FIELD.AMOUNT_DUE"], required: true };
  
  if (resources.LessAmountsDueLabel) {
      fields.LastPaymentCertificateAmount = { visible: true, label: resources.LessAmountsDueLabel, required: true };
  }

  if (placeholdersQA.TaxEnabled) {
      const taxEnabled = placeholdersQA.TaxEnabled?.values
          .find(phItem => phItem.field === 'TaxEnabled').isActive;

      if (taxEnabled) {
        if (resources.TaxSupplierLabel) {
          fields.OtherTaxAmount = { visible: true, label: resources.TaxSupplierLabel, required: true };
        }
      }
  }

  if (placeholdersQA.PONumberEnabled) {
      const poNumberEnabled = placeholdersQA.PONumberEnabled?.values
          .find(phItem => phItem.field === 'PONumberEnabled').isActive;

      if (poNumberEnabled) {
          fields.PurchaseOrderNumber = { visible: true, label: languageFile["CONTRACT.FIELD.PO_NUMBER"], required: false };
      }
  }

  return fields;
}

class PaymentRouter extends React.Component {
  constructor(props) {
    super(props);
    this.clauses = props.workflowItem.clauses;

    try {
      this.taxEnabled = props.placeholdersQA.TaxEnabled
        .values.find(phItem => phItem.field === 'TaxEnabled').isActive;
    } catch (error) {
      console.log("TaxEnabled placeholder not available!");
      this.taxEnabled = true;
    }

    try {
      this.mandateAttachment = props.placeholdersQA.MandateAttachment
        .values.find(phItem => phItem.field === 'MandateAttachment').isActive;
    } catch (error) {
      console.log("MandateAttachment placeholder not available!");
      this.mandateAttachment = false;
    }

    try {
      this.poNumberEnabled = props.placeholdersQA.PONumberEnabled
        .values.find(phItem => phItem.field === 'PONumberEnabled').isActive;
    } catch (error) {
      console.log("PONumberEnabled placeholder not available!");
      this.poNumberEnabled = false;
    }

    if (!this.clauses) {
      ///IF UnifiedClauses not defined use legacy placeholders
      if (props.mode === "SUPPLIER" && props.placeholdersQA.ApplicationTypes) {
        this.clauses = props.placeholdersQA.ApplicationTypes.values.filter(item => item.isActive === true);
      } else if (props.mode === "PM" && props.placeholdersQA.PaymentTypes) {
        this.clauses = props.placeholdersQA.PaymentTypes.values.filter(item => item.isActive === true);
      }
    }
    if (props.mode === "SUPPLIER") {
      this.notificationType = "Application";
      this.documentType = "DocumentApplication";
    } else if (props.mode === "PM") {
      this.notificationType = "Certificate";
      this.documentType = "DocumentCertificate";
    }

    this.notifyingParty = props.workflowItem.notifyingParty;

    this.notificationName = props.workflowItem.notificationName;
    this.abbreviation = props.workflowItem.abbreviation;

  }
  shouldComponentUpdate() {
    return false;
  }

  isCountOfUncompletedAssessmentDateActionsMoreThanZero = () => {
      const items = this.props.filteredManualActions?.items;

      return Array.isArray(items) && items.some(a => a.type === 'PAY_ASSESS');
  }

  getContractorPaymentApplicationActions = () => {
      const items = this.props.filteredManualActions?.items;
      
      return (Array.isArray(items) ? items.filter(a => a.type === 'COMMUNICATE_NOTICE' && a.resolvingworkflowid === 21) : []);
  }

  getClosestDate = (targetDate, items, dateField = 'duedate') => {
      if (!targetDate || !Array.isArray(items) || items.length === 0) {
          return null;
      }

      const target = new Date(targetDate).getTime();

      let closest = items[0];
      let smallestDiff = Math.abs(new Date(items[0][dateField]).getTime() - target);

      items.forEach(item => {
          const currentTime = new Date(item[dateField]).getTime();
          const diff = Math.abs(currentTime - target);

          if (diff < smallestDiff) {
              smallestDiff = diff;
              closest = item;
          }
      });

      return closest;
  };
  
  render() {
    const { workflowItem } = this.props;

    return (
      <>
        <Routes caseSensitive>
          <Route
            path={workflowItem.config.paths.list}
            exact
            element={
              <PaymentList
                {...this.props}
                taxEnabled={this.taxEnabled}
                title={this.notificationName}
                abbreviation={this.abbreviation}
                poNumberEnabled={this.poNumberEnabled}
                clauses={this.clauses}
                notificationType={this.notificationType}
                documentType={this.documentType}
              />
            }
          />
          <Route
            path={workflowItem.config.paths.create}
            exact
            element={
              workflowItem.userFilters.mainNotice.createAllowed ? (
                <PaymentCreate
                  {...this.props}
                  taxEnabled={this.taxEnabled}
                  poNumberEnabled={this.poNumberEnabled}
                  clauses={this.clauses}
                  notificationType={this.notificationType}
                  title={this.notificationName}
                  isCountOfUncompletedAssessmentDateActionsMoreThanZero={this.isCountOfUncompletedAssessmentDateActionsMoreThanZero}
                  contractorPaymentApplicationActions={this.getContractorPaymentApplicationActions}
                  getClosestDate={this.getClosestDate}
                />) : (
                <Navigate replace to={workflowItem.paths.defaultPath} />
              )
            }
          />
          <Route
            path={'/:notificationid/*'}
            exact
            element={
              <PaymentDetail
                {...this.props}
                taxEnabled={this.taxEnabled}
                mandateAttachment={this.mandateAttachment}
                poNumberEnabled={this.poNumberEnabled}
                clauses={this.clauses}
                title={this.notificationName}
                abbreviation={this.abbreviation}
                documentType={this.documentType}
                notificationType={this.notificationType}
                notifyUserFilter={workflowItem.notifyUserFilter}
                isCountOfUncompletedAssessmentDateActionsMoreThanZero={this.isCountOfUncompletedAssessmentDateActionsMoreThanZero}
                contractorPaymentApplicationActions={this.getContractorPaymentApplicationActions}
                getClosestDate={this.getClosestDate}
              />
            }
          />
        </Routes>
      </>
    );
  }
}

const mapStateToProps = store => ({
    filteredManualActions: store.contract.filteredManualActions
});

export default connect(mapStateToProps)(PaymentRouter);
